<script setup lang="ts">
interface Props {
  text?: string
  clickable?: boolean
}
defineProps<Props>()
</script>

<template>
  <div
    class="flex items-center before:me-3 before:flex-1 before:border-t before:border-surface-500 after:ms-3 after:flex-1 after:border-t after:border-surface-500"
    :class="{
      'cursor-pointer': clickable,
    }"
  >
    <span
      v-if="text"
      class="rounded-full border border-surface-500 px-4 py-1 text-sm font-bold"
      :class="{
        'hover:bg-white/10 transition ': clickable,
      }"
    >
      {{ text }}
    </span>
    <slot />
  </div>
</template>
